export const env = {
  API_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',
  DEVTOOLS_PROTECTION_ENABLED:
    import.meta.env.VITE_ENABLE_DEVTOOLS_PROTECTION === 'true',
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',
} as const;
